import { render, staticRenderFns } from "./invoicedetails.vue?vue&type=template&id=1d3fed88&scoped=true&"
import script from "./invoicedetails.vue?vue&type=script&lang=js&"
export * from "./invoicedetails.vue?vue&type=script&lang=js&"
import style0 from "./invoicedetails.vue?vue&type=style&index=0&id=1d3fed88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3fed88",
  null
  
)

export default component.exports